var winWidth = $(window).width();

var scrollBar = function () {

    if (winWidth < 851) {

        $(".psh_table_wrap").each(function () {

            var _this = $(this);
            var _thisTable = _this.find('.psh_table');
            var _thisWidth = _this.outerWidth()
            var _tableWidth = _thisTable.outerWidth();
            var _tableRows = _thisTable.find('.psh_table_row');
            var _totalWidth = (_tableRows.length - 1) * 225;
            var _percentageBar = _this.prev().find('div');

            _thisTable.css('width', _totalWidth + 'px');

            _this.scroll(function () {
                var scrollPercentage = 100 * $(this).scrollLeft() / (_totalWidth - _thisWidth);
                _percentageBar.css({ 'width': scrollPercentage + '%' });
            });

        });

    }

};

scrollBar();

$('.psh_table_header').on('click', function () {
    if (winWidth < 851) {
        $(this).toggleClass('is-expanded');
    }
});

$('.psh_table_header_year').on('click', function () {
    if (winWidth >= 850) {
        $(this).closest('.psh_table_header').toggleClass('is-expanded');
    }
});

$('.psh_table_header_icon').on('click', function () {
    if (winWidth >= 850) {
        $(this).closest('.psh_table_header').toggleClass('is-expanded');
    }
});